// any app specific constants that you don't want to keep in config can go here.
export const SYSTEM_ERROR = "System error. Please try again later!";
export const CTA_YES = "Yes";
export const CTA_NO = "No";
export const CTA_CANCEL = "Cancel";
export const MINIMUM_DATE = "2019-12-31";
export const ADMIN_ACCESS =
  "steve.miles@ttec.com;nate.bullock@ttec.com;liz.torres@ttec.com;anuranjan.prasad@ttec.com;mohammedrizwan.memon@ttec.com;sarath.srimusuru@ttec.com;ramya.nagepalli@ttec.com";
